// Mock data for Brand Personality Quiz
// HYBRID A+B+C UPDATE: Rebalanced mappings + Reframed labels + Weighted scoring

// Archetype weights to normalize scoring (Option C)
// Lower weights for over-represented archetypes, higher for under-represented
export const ARCHETYPE_WEIGHTS = {
  "Sage": 0.95,        // 21 appearances
  "Lover": 1.05,       // 19 appearances
  "Ruler": 1.05,       // 19 appearances
  "Everyman": 1.11,    // 18 appearances
  "Hero": 1.33,        // 15 appearances
  "Caregiver": 1.43,   // 14 appearances
  "Rebel": 1.54,      // 13 appearances
  "Jester": 1.82,      // 11 appearances
  "Innocent": 1.82,    // 11 appearances
  "Creator": 1.82,     // 11 appearances
  "Explorer": 1.82,    // 11 appearances
  "Magician": 1.82,    // 11 appearances
};

export const personalityQuestions = [
  // P1: No change
  {
    id: 1,
    leftTrait: "Playful",
    rightTrait: "Serious",
    leftArchetypes: ["Jester", "Lover", "Innocent"],
    rightArchetypes: ["Sage", "Ruler", "Creator"]
  },
  // P2: No change
  {
    id: 2,
    leftTrait: "Bold",
    rightTrait: "Careful",
    leftArchetypes: ["Hero", "Rebel", "Explorer"],
    rightArchetypes: ["Caregiver", "Innocent", "Sage"]
  },
  // P3: Labels updated + Everyman moved RIGHT
  {
    id: 3,
    leftTrait: "Heritage-Inspired",
    rightTrait: "Forward-Thinking",
    leftArchetypes: ["Sage", "Caregiver", "Creator"],
    rightArchetypes: ["Magician", "Explorer", "Ruler", "Everyman"]
  },
  // P4: Labels updated + Caregiver removed from LEFT
  {
    id: 4,
    leftTrait: "Supportive",
    rightTrait: "Empowering",
    leftArchetypes: ["Lover", "Innocent"],
    rightArchetypes: ["Rebel", "Hero", "Explorer"]
  },
  // P5: Swap Innocent<->Sage
  {
    id: 5,
    leftTrait: "Free-spirited",
    rightTrait: "Disciplined",
    leftArchetypes: ["Explorer", "Jester", "Sage"],
    rightArchetypes: ["Ruler", "Innocent", "Creator"]
  },
  // P6: Add Hero, Everyman to LEFT
  {
    id: 6,
    leftTrait: "Spontaneous",
    rightTrait: "Planned",
    leftArchetypes: ["Jester", "Rebel", "Hero", "Everyman"],
    rightArchetypes: ["Ruler", "Sage"]
  },
  // P7: Labels updated + Major reshuffle
  {
    id: 7,
    leftTrait: "Emotion-Centered",
    rightTrait: "Logic-Centered",
    leftArchetypes: ["Lover", "Magician", "Ruler"],
    rightArchetypes: ["Sage", "Caregiver"]
  },
  // P8: Major reshuffle - Caregiver/Innocent moved RIGHT
  {
    id: 8,
    leftTrait: "Humble",
    rightTrait: "Confident",
    leftArchetypes: ["Rebel", "Hero", "Everyman"],
    rightArchetypes: ["Innocent", "Ruler", "Magician", "Caregiver"]
  },
  // P9: Hero LEFT, Lover RIGHT
  {
    id: 9,
    leftTrait: "Realistic",
    rightTrait: "Idealistic",
    leftArchetypes: ["Everyman", "Sage", "Hero"],
    rightArchetypes: ["Magician", "Creator", "Lover"]
  },
  // P10: Labels updated + Innocent/Everyman moved RIGHT
  {
    id: 10,
    leftTrait: "Intimate",
    rightTrait: "Mysterious",
    leftArchetypes: ["Lover", "Explorer", "Caregiver"],
    rightArchetypes: ["Sage", "Innocent", "Everyman"]
  },
  // P11: Label updated + Lover/Caregiver moved RIGHT
  {
    id: 11,
    leftTrait: "Approachable",
    rightTrait: "Premium",
    leftArchetypes: ["Everyman", "Jester"],
    rightArchetypes: ["Ruler", "Creator", "Caregiver", "Lover"]
  },
  // P12: Lover/Innocent moved RIGHT
  {
    id: 12,
    leftTrait: "Imaginative",
    rightTrait: "Practical",
    leftArchetypes: ["Creator", "Magician", "Hero"],
    rightArchetypes: ["Sage", "Innocent", "Everyman", "Lover"]
  },
  // P13: Sage/Ruler/Caregiver now LEFT
  {
    id: 13,
    leftTrait: "Calm",
    rightTrait: "Energetic",
    leftArchetypes: ["Sage", "Ruler", "Caregiver"],
    rightArchetypes: ["Hero", "Rebel", "Jester"]
  },
  // P14: Labels updated + Innocent/Lover moved RIGHT
  {
    id: 14,
    leftTrait: "Reassuring",
    rightTrait: "Bold",
    leftArchetypes: ["Everyman", "Sage"],
    rightArchetypes: ["Rebel", "Jester", "Hero", "Innocent", "Lover"]
  },
  // P15: Major reshuffle
  {
    id: 15,
    leftTrait: "Grounded",
    rightTrait: "Visionary",
    leftArchetypes: ["Rebel", "Sage", "Lover"],
    rightArchetypes: ["Magician", "Creator", "Ruler", "Everyman"]
  }
];

export const traitQuestions = [
  // T1
  {
    id: 1,
    leftTrait: "Trusted Guide",
    rightTrait: "Bold Transformer",
    leftArchetypes: ["Sage", "Everyman"],
    rightArchetypes: ["Rebel", "Hero", "Magician", "Caregiver", "Lover"]
  },
  // T2
  {
    id: 2,
    leftTrait: "Timeless Elegance",
    rightTrait: "Creative Innovation",
    leftArchetypes: ["Ruler", "Lover"],
    rightArchetypes: ["Creator", "Rebel", "Everyman"]
  },
  // T3: right label "Fresh & Spontaneous"
  {
    id: 3,
    leftTrait: "Familiar & Trusted",
    rightTrait: "Fresh & Spontaneous",
    leftArchetypes: ["Everyman", "Sage"],
    rightArchetypes: ["Jester", "Rebel", "Caregiver", "Lover"]
  },
  // T4
  {
    id: 4,
    leftTrait: "Dynamic Presence",
    rightTrait: "Calm Authority",
    leftArchetypes: ["Hero", "Jester", "Explorer"],
    rightArchetypes: ["Sage", "Ruler"]
  },
  // T5 (was T9)
  {
    id: 5,
    leftTrait: "Inspirational Leader",
    rightTrait: "Supportive Partner",
    leftArchetypes: ["Hero", "Ruler"],
    rightArchetypes: ["Everyman", "Caregiver", "Lover"]
  },
  // T6 (was T11): Story-Driven vs Evidence-Driven
  {
    id: 6,
    leftTrait: "Story-Driven",
    rightTrait: "Evidence-Driven",
    leftArchetypes: ["Lover", "Magician", "Hero"],
    rightArchetypes: ["Sage", "Ruler", "Everyman"]
  },
  // T7 (was T13)
  {
    id: 7,
    leftTrait: "Community-Powered",
    rightTrait: "Individual Excellence",
    leftArchetypes: ["Everyman", "Jester", "Caregiver"],
    rightArchetypes: ["Hero", "Explorer", "Lover"]
  },
  // T8 (was T14): Disciplined & Orderly vs Rebellion & Boundary-Pushing
  {
    id: 8,
    leftTrait: "Disciplined & Orderly",
    rightTrait: "Rebellion & Boundary-Pushing",
    leftArchetypes: ["Ruler", "Sage"],
    rightArchetypes: ["Rebel", "Explorer"]
  },
  // T9 (was T15): Rich & Textural vs Clean & Minimal
  {
    id: 9,
    leftTrait: "Rich & Textural",
    rightTrait: "Clean & Minimal",
    leftArchetypes: ["Lover", "Creator", "Innocent"],
    rightArchetypes: ["Sage", "Ruler", "Everyman"]
  },
  // T10 (was T17): Wonder & Magic vs Know-How & Expertise
  {
    id: 10,
    leftTrait: "Wonder & Magic",
    rightTrait: "Know-How & Expertise",
    leftArchetypes: ["Magician", "Lover", "Rebel"],
    rightArchetypes: ["Sage", "Ruler"]
  },
  // T11 (was T19)
  {
    id: 11,
    leftTrait: "Relatable & Authentic",
    rightTrait: "Aspirational & Premium",
    leftArchetypes: ["Everyman", "Caregiver"],
    rightArchetypes: ["Ruler", "Creator", "Lover"]
  },
  // T12 (was T21): Grounded & Honest vs Futuristic & Transformative
  {
    id: 12,
    leftTrait: "Grounded & Honest",
    rightTrait: "Futuristic & Transformative",
    leftArchetypes: ["Everyman", "Hero", "Innocent"],
    rightArchetypes: ["Magician", "Creator", "Lover"]
  },
  // T13 (NEW): Curiosity-Led vs Goal-Driven
  {
    id: 13,
    leftTrait: "Curiosity-Led",
    rightTrait: "Goal-Driven",
    leftArchetypes: ["Explorer", "Jester", "Magician"],
    rightArchetypes: ["Hero", "Caregiver"]
  },
  // T14 (NEW): Playful Wit vs Deep Expertise
  {
    id: 14,
    leftTrait: "Playful Wit",
    rightTrait: "Deep Expertise",
    leftArchetypes: ["Jester", "Explorer"],
    rightArchetypes: ["Sage", "Ruler"]
  },
  // T15 (NEW): Security & Stability vs Thrill & Discovery
  {
    id: 15,
    leftTrait: "Security & Stability",
    rightTrait: "Thrill & Discovery",
    leftArchetypes: ["Innocent", "Sage", "Ruler"],
    rightArchetypes: ["Explorer", "Rebel", "Caregiver"]
  }
];

export const visualAttributeQuestions = [
  {
    id: 1,
    option1: "Minimalist",
    option2: "Maximalist"
  },
  {
    id: 2,
    option1: "Retro/Vintage",
    option2: "Modern"
  },
  {
    id: 3,
    option1: "Traditional/Ethnic",
    option2: "Contemporary/Global"
  },
  {
    id: 4,
    option1: "Corporate/Professional",
    option2: "Artistic/Expressive"
  },
  {
    id: 5,
    option1: "Warm",
    option2: "Formal"
  },
  {
    id: 6,
    option1: "Playful/Fun",
    option2: "Sophisticated/Classic"
  },
  {
    id: 7,
    option1: "Natural",
    option2: "Industrial"
  },
  {
    id: 8,
    option1: "Quirky/Whimsical",
    option2: "Formal / Direct"
  },
  {
    id: 9,
    option1: "Masculine",
    option2: "Feminine"
  },
  {
    id: 10,
    option1: "Futuristic/High-Tech",
    option2: "Modern/Everyday"
  },
  {
    id: 11,
    option1: "Eco/Sustainable",
    option2: "Premium/Luxurious"
  },
  {
    id: 12,
    option1: "Organic",
    option2: "Geometric"
  },
  {
    id: 13,
    option1: "Ornate",
    option2: "Understated"
  },
  {
    id: 14,
    option1: "Bold/Vibrant",
    option2: "Subtle/Refined"
  }
];

export const archetypeDescriptions = {
  "Innocent": {
    description: "Sees the good in everything and everyone, believes in a happy ending, seeks to maintain purity and goodness.",
    keywords: ["Pure", "Optimistic", "Wholesome", "Gentle"],
    coreTraits: ["Purity", "Optimism", "Wholesomeness", "Reassurance", "Gentleness"],
    visualStyle: "Clean, simple, light, airy, bright, uncluttered",
    colors: "Cool or neutral palette with earthy tones (pastels, light blues, greens, whites, creams)",
    typography: "Rounded, friendly sans-serifs",
    brandCharacteristics: "Trustworthy, ethical, approachable, wholesome, safe",
    toneOfVoice: "Pure, optimistic, wholesome, reassuring, gentle"
  },
  "Explorer": {
    description: "Seeks freedom, wants to discover themselves and the world, is restless and eager for new experiences, values authenticity.",
    keywords: ["Adventurous", "Independent", "Curious", "Authentic"],
    coreTraits: ["Adventure", "Independence", "Curiosity", "Authenticity"],
    visualStyle: "Rugged, natural, adventurous, open, expansive",
    colors: "Lighter tones paired with vibrant colours (blues, greens, browns, oranges, yellows)",
    typography: "Sans-serif with rugged, unruly undertones",
    brandCharacteristics: "Inspiring, free-spirited, authentic, daring, pioneering",
    toneOfVoice: "Adventurous, independent, curious, authentic"
  },
  "Sage": {
    description: "Seeks truth and understanding, values knowledge and intellect, provides guidance and expertise, believes in learning.",
    keywords: ["Wise", "Knowledgeable", "Trustworthy", "Educational"],
    coreTraits: ["Knowledge", "Wisdom", "Truth", "Expertise"],
    visualStyle: "Clean, sophisticated, intellectual, organized, calm",
    colors: "Vibrancy and emphasis is key with sophisticated palette (deep blues, grays, whites, subtle pops of accent)",
    typography: "Serif + clean sans-serif combinations",
    brandCharacteristics: "Trustworthy, intelligent, authoritative, informative, reliable",
    toneOfVoice: "Knowledgeable, trustworthy, educational, fact-driven"
  },
  "Hero": {
    description: "Wants to prove their worth through courageous acts, seeks to improve the world, is driven by a desire to overcome challenges and win.",
    keywords: ["Brave", "Strong", "Determined", "Empowering"],
    coreTraits: ["Courage", "Strength", "Mastery", "Determination"],
    visualStyle: "Bold, strong, dynamic, impactful, action-oriented",
    colors: "Bold colours, strong contrasts, often with metallic accents (reds, blues, golds, silvers)",
    typography: "Bold sans-serifs",
    brandCharacteristics: "Empowering, resilient, ambitious, successful, high-achieving",
    toneOfVoice: "Bold, confident, empowering, action-oriented"
  },
  "Rebel": {
    description: "Seeks to overturn what isn't working, challenges the status quo, values freedom and individuality, can be provocative and dangerous.",
    keywords: ["Rebellious", "Bold", "Disruptive", "Free"],
    coreTraits: ["Rebellion", "Liberation", "Disruption", "Revolution"],
    visualStyle: "Gritty, raw, unconventional, edgy, disruptive",
    colors: "Matte, metallic, rough textures (blacks, grays, deep reds, electric blues, stark whites)",
    typography: "Distressed/industrial bold fonts",
    brandCharacteristics: "Provocative, disruptive, unconventional, bold, freedom-loving",
    toneOfVoice: "Rebellious, provocative, daring, anti-conventional"
  },
  "Magician": {
    description: "Wants to understand the fundamental laws of the universe, seeks to create, transform, and manifest visions, has a charismatic and visionary nature.",
    keywords: ["Transformative", "Visionary", "Innovative", "Inspiring"],
    coreTraits: ["Transformation", "Innovation", "Vision", "Power"],
    visualStyle: "Mystical, ethereal, futuristic, transformative, awe-inspiring",
    colors: "Holographic foils, iridescent textures (purples, blues, blacks, silvers, shimmering effects)",
    typography: "Elegant serif + script",
    brandCharacteristics: "Transformative, innovative, inspiring, visionary, powerful",
    toneOfVoice: "Transformational, aspirational, mystical, innovative"
  },
  "Everyman": {
    description: "Wants to belong and connect with others, values honesty and authenticity, is down-to-earth and practical, seeks to blend in.",
    keywords: ["Relatable", "Authentic", "Friendly", "Genuine"],
    coreTraits: ["Relatability", "Belonging", "Connection", "Authenticity"],
    visualStyle: "Simple, straightforward, accessible, friendly, unpretentious",
    colors: "Clean sans-serifs (blues, grays, whites, muted tones)",
    typography: "Clean sans-serifs",
    brandCharacteristics: "Reliable, dependable, accessible, friendly, genuine",
    toneOfVoice: "Friendly, relatable, down-to-earth, approachable"
  },
  "Lover": {
    description: "Seeks connection, intimacy, and sensory pleasure, values beauty and harmony, is passionate and devoted.",
    keywords: ["Passionate", "Intimate", "Sensual", "Elegant"],
    coreTraits: ["Intimacy", "Passion", "Connection", "Sensuality"],
    visualStyle: "Sensual, elegant, intimate, luxurious, aesthetically pleasing",
    colors: "Elegant serif or handwritten (deep reds, pinks, golds, creams, soft pastels)",
    typography: "Elegant serif or handwritten",
    brandCharacteristics: "Indulgent, desirable, passionate, sophisticated, intimate",
    toneOfVoice: "Sensual, indulgent, emotionally engaging, warm"
  },
  "Jester": {
    description: "Lives in the moment, enjoys fun and humor, disrupts with playfulness, doesn't take things too seriously, seeks to lighten the mood.",
    keywords: ["Playful", "Fun", "Energetic", "Whimsical"],
    coreTraits: ["Fun", "Humor", "Spontaneity", "Playfulness"],
    visualStyle: "Playful, energetic, vibrant, quirky, whimsical",
    colors: "Bright, contrasting colors (yellow, orange, pink, turquoise)",
    typography: "Rounded, quirky sans-serifs or combination of serif and sans-serifs",
    brandCharacteristics: "Fun, lighthearted, engaging, unpredictable, memorable",
    toneOfVoice: "Fun, playful, irreverent, energetic, whimsical"
  },
  "Caregiver": {
    description: "Wants to protect and care for others, is compassionate and generous, seeks to help and serve, prioritizes the well-being of others.",
    keywords: ["Compassionate", "Nurturing", "Supportive", "Empathetic"],
    coreTraits: ["Compassion", "Generosity", "Nurturing", "Service"],
    visualStyle: "Gentle, caring, supportive, warm, safe",
    colors: "Soft blues, greens, whites, gentle pastels",
    typography: "Rounded sans-serifs",
    brandCharacteristics: "Supportive, trustworthy, reliable, kind, empathetic",
    toneOfVoice: "Nurturing, supportive, trustworthy, empathetic"
  },
  "Ruler": {
    description: "Seeks control and order, wants to create abundance and prosperity, is a natural leader, values power and status.",
    keywords: ["Authoritative", "Prestigious", "Powerful", "Confident"],
    coreTraits: ["Control", "Leadership", "Order", "Responsibility"],
    visualStyle: "Regal, authoritative, luxurious, polished, sophisticated",
    colors: "Deep purples, golds, blacks, rich blues, emerald greens",
    typography: "Classic serif or structured sans-serif",
    brandCharacteristics: "Prestigious, high-quality, authoritative, exclusive, successful",
    toneOfVoice: "Authoritative, premium, aspirational, controlled"
  },
  "Creator": {
    description: "Driven by a desire to create, innovates and expresses themselves, seeks to bring something new into existence, values imagination and originality.",
    keywords: ["Creative", "Innovative", "Artistic", "Original"],
    coreTraits: ["Innovation", "Imagination", "Artistry", "Self-expression"],
    visualStyle: "Artistic, imaginative, innovative, expressive, unique",
    colors: "A wide spectrum, often bold and unconventional combinations",
    typography: "Creative sans-serifs",
    brandCharacteristics: "Innovative, original, imaginative, inspiring, artistic",
    toneOfVoice: "Innovative, imaginative, expressive, artistic"
  }
};

// Weighted calculation function matching backend quiz_engine.py logic
export const calculateArchetypes = (personalityAnswers, traitAnswers) => {
  const rawCounts = {};

  // Process personality questions (Section 1)
  personalityAnswers.forEach((answer, index) => {
    const question = personalityQuestions[index];
    if (!question) return;
    const selectedArchetypes = answer === 'left' ? question.leftArchetypes : question.rightArchetypes;
    selectedArchetypes.forEach(archetype => {
      rawCounts[archetype] = (rawCounts[archetype] || 0) + 1;
    });
  });

  // Process trait questions (Section 2)
  traitAnswers.forEach((answer, index) => {
    const question = traitQuestions[index];
    if (!question) return;
    const selectedArchetypes = answer === 'left' ? question.leftArchetypes : question.rightArchetypes;
    selectedArchetypes.forEach(archetype => {
      rawCounts[archetype] = (rawCounts[archetype] || 0) + 1;
    });
  });

  // Apply weights to get weighted scores
  const weightedScores = {};
  Object.entries(rawCounts).forEach(([archetype, count]) => {
    const weight = ARCHETYPE_WEIGHTS[archetype] || 1.0;
    weightedScores[archetype] = count * weight;
  });

  // Sort by weighted score descending
  const sortedArchetypes = Object.entries(weightedScores)
    .sort((a, b) => b[1] - a[1])
    .map(([archetype, weightedScore]) => ({
      archetype,
      count: rawCounts[archetype],
      weightedScore: Math.round(weightedScore * 100) / 100
    }));

  return {
    dominant: sortedArchetypes[0]?.archetype || "Everyman",
    secondary: sortedArchetypes[1]?.archetype || "Caregiver",
    allScores: sortedArchetypes
  };
};
